import { useCallback, useContext } from 'react';

import { OrderActionContext } from '../components/OrderActionProvider';

const OPEN_AMEND = 'AMEND';
const OPEN_WITHDRAW = 'WITHDRAW';

const ACCOUNT_REGULAR = 'REGULAR';
const ACCOUNT_DT = 'DAY_TRADING';
const ACCOUNT_MT = 'MARGIN_TRADING';

const ORDER_LIMIT = 'LIMIT';

/**
 * @callback  CbAmendWithdraw
 * @param   {object}  ObjectParam
 * @returns {void}
 */

/**
 * Need to wrap inside '@screens/BottomContent/Stock/Order/components/OrderActionProvider'
 * @param {ACCOUNT_REGULAR|ACCOUNT_DT|ACCOUNT_MT}   accountType
 */
function useOrderAction(accountType = ACCOUNT_REGULAR) {
  const { setPopup } = useContext(OrderActionContext);

  /** @type {CbAmendWithdraw} */
  const amend = useCallback(
    (orderDetail) => {
      setPopup({
        open: OPEN_AMEND,
        data: { accountType, orderType: ORDER_LIMIT, orderDetail },
      });
    },
    [setPopup]
  );

  /** @type {CbAmendWithdraw} */
  const withdraw = useCallback(
    (orderDetail) => {
      setPopup({
        open: OPEN_WITHDRAW,
        data: { accountType, orderType: ORDER_LIMIT, orderDetail },
      });
    },
    [setPopup]
  );

  return {
    amend,
    withdraw,
  };
}

export default useOrderAction;
